<template>
  <div>
    <div
      class="btn-sm-drop statusbtn"
      v-show="fromList && !dropdownReady"
      @click.stop="activateDropdown"
    >
      <button type="button" class="btn btn-secondary m-md-2">
        {{ currentStatus }} <span>▼</span>
      </button>
    </div>
    <b-dropdown
      v-if="dropdownReady"
      :id="dropdownId"
      :text="currentStatus + '▼'"
      class="btn-sm-drop statusbtn m-md-2"
      @hidden="$emit('hidden')"
      @shown="$emit('shown')"
      ref="bDropdown"
      @hook:mounted="onDropdownMounted"
    >
      <b-dropdown-item
        v-for="(status, index) in client_status"
        v-bind:key="index"
        v-on:click="changeStatus(status)"
        :disabled="toggledisabledstatus"
      >
        {{ status }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations } from 'vuex';

export default {
  name: 'Dropdown',
  props: ['applicant', 'toggledisabledstatus', 'isReviewer', 'fromList'],
  data() {
    return {
      dropdownReady: !this.fromList,
      openOnMount: false,
    };
  },
  computed: {
    currentStatus() {
      return this.applicant.new_status || this.applicant.status;
    },
    client_status() {
      return this.$store.getters.getClientStatus;
    },
    dropdownId() {
      return `status-dd-${this.applicant.id}`;
    },
  },
  methods: {
    ...mapMutations({
      mutateApplicantsAfterStatus: 'mutateApplicantsAfterStatus',
    }),
    activateDropdown() {
      this.openOnMount = true;
      this.dropdownReady = true;
    },
    onDropdownMounted() {
      if (!this.openOnMount) return;
      this.openOnMount = false;
      this.$nextTick(() => {
        const dropdown = this.$refs.bDropdown;
        if (dropdown) {
          dropdown.show();
        }
        this.$emit('shown');
      });
    },
    changeStatus(status) {
      ApiService.put(Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id), {
        status,
        isNewPanel: true,
      })
        .then(({ data }) => {
          this.$emit('statusChanged', data.data);
          this.mutateApplicantsAfterStatus(data.data, this.isReviewer);
          if (this.fromList) {
            this.dropdownReady = false;
          }
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
  },
};
</script>
<style scoped>
::v-deep .dropdown-toggle::after {
  display: none !important;
}

.statusbtn button {
  transition: background-color 0.2s, border-color 0.2s;
}

.statusbtn button:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
  color: #3c3c3c !important;
}
</style>
